import { Component, Inject, Input } from '@angular/core';
import { contractModificationsWizardSteps } from 'src/app/models/wizard-enum';
import { DateInputSize, DateInputRounded, DateInputFillMode } from '@progress/kendo-angular-dateinputs';
import { FileStoreAPIService } from 'src/app/extensions/services/api/file-store-api.service';
import { ENV_CONFIG } from 'src/app/core/injection.token';

@Component({
  selector: 'contract-modification-type',
  templateUrl: './modification-type.component.html',
  styleUrls: ['./modification-type.component.scss'],
  standalone: false,
})
export class ModificationTypeComponent {
  public wizardStepsEnum = contractModificationsWizardSteps;

  @Input()
  DICTIONARY_CONTRACT_MODIFICATION_TYPE: app.models.DictionaryContractModificationRequestType;
  @Input() contractsDataSource: any[];
  @Input() contractModificationRequestType: app.models.DictionaryDataModel[];
  @Input() reimbursementTypeDatasource: app.models.DictionaryDataModel[];
  @Input() contractModificationRequest: app.models.ContractModificationRequest;
  @Input() modificationTypeDisabled: boolean;

  @Input() contractSelectHandler: any;
  @Input() contractModificationRequestTypeChangeHandler: any;
  @Input() contractModificationReimbursementTypeChangeHandler: any;
  @Input() nextStepHandler: any;
  @Input() deleteFileHandler: any;
  @Input() uploadFilesHandler: any;

  public fillModeOutline: DateInputFillMode = 'outline';
  public roundedLarge: DateInputRounded = 'large';
  public sizeLarge: DateInputSize = 'large';

  public documentName: string;
  constructor(
    private _fileStoreAPIService: FileStoreAPIService,
    @Inject(ENV_CONFIG) private _envConfig: env.EnvConfigurationData
  ) {
    this.documentName = this._envConfig.CONTRACT_MODIFICATION_DIRECT_DEBIT_TEMPLATE;
  }

  public downloadDocument(documentName: string): void {
    if (documentName) {
      this._fileStoreAPIService.getFile(documentName).subscribe(response => {
        if (response) {
          const extension = documentName.split('.').pop()?.toLowerCase();
          const documentRef = `data:application/${extension};base64,${response}`;
          const downloadLink = document.createElement('a');

          downloadLink.href = documentRef;
          downloadLink.download = documentName;
          downloadLink.click();
        }
      });
    }
  }

  public getFileTypeIcon(filename: string): string {
    const extension = filename.split('.').pop()?.toLowerCase();

    switch (extension) {
      case 'pdf':
        return 'file-pdf';
      case 'doc':
      case 'docx':
        return 'file-word';
      default:
        return 'file-pdf';
    }
  }
}
